import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { func, string, bool, number } from 'prop-types'

import { filterType, categoriesType, trackingRoomInfoType } from 'models/propTypes'

import {
    getFilter,
    getCategories,
    getIsFilterActive,
    getNumberFurnitureItems,
    getFurnitureIsLoading,
    getIsCategoriesLoading,
} from 'models/furniture/selectors'
import { DEBUG_CATEGORY } from 'models/furniture/constants'
import { getFilterModalOpen } from 'models/ui/selectors'
import { getSubCatalog } from 'models/location/selectors'
import { getIsAdmin } from 'models/user/selectors'
import {
    updateFurnitureFilter as updateFurnitureFilterAction,
    clearFurnitureFilter as clearFurnitureFilterAction,
    requestFurnitureCategories as requestFurnitureCategoriesAction,
    filterFeaturedProducts as filterFeaturedProductsAction,
} from 'models/furniture/actions'
import { setShowFilterModal as setShowFilterModalAction } from 'models/ui/actions'
import { getSelectedCompositionTrackingRoomInfo, getSelectedSceneRoomType } from 'models/compositions/selectors'

import ProductFilter from 'components/designSidepanel/ProductFilter'

const ProductFilterContainer = ({
    furnitureFilter,
    updateFurnitureFilter,
    clearFurnitureFilter,
    filterFeaturedProducts,
    isFilterActive,
    numberProductItems,
    furnitureIsLoading,
    isCategoriesLoading,
    urlSubCatalog,
    showFilterModal,
    setShowFilterModal,
    loadCategories,
    categories,
    isAdmin,
    roomInfo,
    roomType,
}) => {
    useEffect(() => {
        if (!categories.length && !isCategoriesLoading) {
            loadCategories()
        }
    }, [])

    const filterDebugFurniture = () => {
        updateFurnitureFilter({ category: DEBUG_CATEGORY })
    }

    const hasFeaturedProducts = !!(urlSubCatalog || roomType)

    return (
        <ProductFilter
            furnitureFilter={furnitureFilter}
            categories={categories}
            updateFurnitureFilter={updateFurnitureFilter}
            filterFeaturedFurniture={filterFeaturedProducts}
            filterDebugFurniture={filterDebugFurniture}
            clearFurnitureFilter={clearFurnitureFilter}
            isFilterActive={isFilterActive}
            numberProductItems={numberProductItems}
            furnitureIsLoading={furnitureIsLoading}
            isCategoriesLoading={isCategoriesLoading}
            setShowFilterModal={setShowFilterModal}
            showFilterModal={showFilterModal}
            hasDebugCategory={isAdmin}
            hasFeaturedProducts={hasFeaturedProducts}
            roomInfo={roomInfo}
        />
    )
}

ProductFilterContainer.defaultProps = {
    urlSubCatalog: null,
    roomInfo: null,
    roomType: null,
}

ProductFilterContainer.propTypes = {
    furnitureFilter: filterType.isRequired,
    updateFurnitureFilter: func.isRequired,
    categories: categoriesType.isRequired,
    clearFurnitureFilter: func.isRequired,
    isFilterActive: bool.isRequired,
    numberProductItems: number.isRequired,
    furnitureIsLoading: bool.isRequired,
    isCategoriesLoading: bool.isRequired,
    urlSubCatalog: string,
    setShowFilterModal: func.isRequired,
    showFilterModal: bool.isRequired,
    loadCategories: func.isRequired,
    isAdmin: bool.isRequired,
    roomInfo: trackingRoomInfoType,
    roomType: string,
    filterFeaturedProducts: func.isRequired,
}

const mapStateToProps = (state) => ({
    furnitureFilter: getFilter(state),
    categories: getCategories(state),
    isFilterActive: getIsFilterActive(state),
    numberProductItems: getNumberFurnitureItems(state),
    furnitureIsLoading: getFurnitureIsLoading(state),
    isCategoriesLoading: getIsCategoriesLoading(state),
    urlSubCatalog: getSubCatalog(state),
    showFilterModal: getFilterModalOpen(state),
    isAdmin: getIsAdmin(state),
    roomInfo: getSelectedCompositionTrackingRoomInfo(state),
    roomType: getSelectedSceneRoomType(state),
})

const mapDispatchToProps = {
    updateFurnitureFilter: updateFurnitureFilterAction,
    clearFurnitureFilter: clearFurnitureFilterAction,
    setShowFilterModal: setShowFilterModalAction,
    loadCategories: requestFurnitureCategoriesAction,
    filterFeaturedProducts: filterFeaturedProductsAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductFilterContainer)
